import React from 'react'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import FormHighlightData from '../../forms/FormHighlightData.jsx'
import sortCinemas from '../../../functions/sortCinemas'
import Translation from '../../Translation/cont/Translation'

const EditHighlight = ({itemData, onUpdateItem, movieData, closePagePath, suffixEdit, sortedMovieDataKeys, cliCinemas, features, clientCinemaId}) => {
    const pageName = itemData && itemData.title ? itemData.title : <Translation id="highlight_default_page_name">Neues Highlight</Translation>
    const cliCinemasIdList = sortCinemas(clientCinemaId, cliCinemas)
    return (
        <WrapperPageSimple pageTitle={pageName} closePagePath={closePagePath}>
            <div className="program-page site-content">
                {itemData ? (
                    <FormHighlightData
                        contentData={itemData} 
                        onUpdateHighlight={onUpdateItem}
                        features={features}
                        closePagePath={closePagePath}
                        suffixEdit={suffixEdit}
                        movieData={movieData}
                        cliCinemas={cliCinemas}
                        cliCinemasIdList={cliCinemasIdList}
                        sortedMovieDataKeys={sortedMovieDataKeys}
                        clientCinemaId={clientCinemaId}
                    />
                ):(
                    <div><Translation id="no_data"/></div>
                )}
            </div>
        </WrapperPageSimple>
    )
}

export default EditHighlight